import { ConsultationCalendarPicker } from 'components/CalendarPicker/ConsultationCalendarPicker';
import { useConsultationCalendar } from 'domains/calendars/v3/useConsultationCalendar';
import { ConsultationFormType } from 'domains/signupDirect/schemas/consultationSchema';
import { useDisplayTimezone } from 'domains/timezone/useDisplayTimezone';
import { FC, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

const Component: FC = () => {
  const calendarData = useConsultationCalendar({
    queryFrom: new Date(),
  });

  const { setValue } = useFormContext<ConsultationFormType>();

  const { displayTimezone } = useDisplayTimezone();

  useEffect(() => {
    if (displayTimezone) setValue('consultSchedule.timeZone', displayTimezone.resolvedName);
  }, [displayTimezone]);

  return <ConsultationCalendarPicker calendarData={calendarData} name="consultSchedule.time" />;
};

export const ScheduleSection = Component;
